import api from '../../store/config/api';
import {
  TABLE as SCHEMA,
  FIELD as FIELD_SCHEMA,
  FILE as FILE_SCHEMA,
  PROCESS_LIST as PROCESS_LIST_SCHEMA
} from '../../schemas';

export const [
  GET_TABLE,
  GET_TABLE_REQUEST,
  GET_TABLE_SUCCESS,
  GET_TABLE_FAILURE
] = api.buildTypes('GET_TABLE');

export function getTable({ teamName, tableID }) {
  return {
    type: GET_TABLE,
    payload: {
      url: `/teams/${teamName}/tables/${tableID}`,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  ADD_TABLE,
  ADD_TABLE_REQUEST,
  ADD_TABLE_SUCCESS,
  ADD_TABLE_FAILURE
] = api.buildTypes('ADD_TABLE');

export function addTable({ teamName, table = {} }) {
  return {
    type: ADD_TABLE,
    payload: {
      url: `/teams/${teamName}/tables`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: table
      }
    }
  };
}

export const [
  UPDATE_TABLE,
  UPDATE_TABLE_REQUEST,
  UPDATE_TABLE_SUCCESS,
  UPDATE_TABLE_FAILURE
] = api.buildTypes('UPDATE_TABLE');

export const updateTable = ({ teamName, tableID, table = {} }) => ({
  type: UPDATE_TABLE,
  payload: {
    url: `/teams/${teamName}/tables/${tableID}`,
    schema: SCHEMA,
    options: {
      method: 'PUT',
      body: table
    }
  }
});

export const [
  IMPORT_TABLE,
  IMPORT_TABLE_REQUEST,
  IMPORT_TABLE_SUCCESS,
  IMPORT_TABLE_FAILURE
] = api.buildTypes('IMPORT_TABLE');

export function importTable({ teamName, body }) {
  return {
    type: IMPORT_TABLE,
    payload: {
      url: `/teams/${teamName}/tables/import`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body
      }
    }
  };
}

export const [
  EXPORT_TABLE,
  EXPORT_TABLE_REQUEST,
  EXPORT_TABLE_SUCCESS,
  EXPORT_TABLE_FAILURE
] = api.buildTypes('EXPORT_TABLE');

export function exportTable({ teamName, tableID, exportType }) {
  return {
    type: EXPORT_TABLE,
    payload: {
      url: `/teams/${teamName}/tables/${tableID}/export`,
      schema: FILE_SCHEMA,
      options: {
        method: 'POST',
        body: { exportType }
      }
    }
  };
}

export const [
  REPLACE_TABLE,
  REPLACE_TABLE_REQUEST,
  REPLACE_TABLE_SUCCESS,
  REPLACE_TABLE_FAILURE
] = api.buildTypes('REPLACE_TABLE');

export function replaceTable({ teamName, tableID, body }) {
  return {
    type: REPLACE_TABLE,
    payload: {
      url: `/teams/${teamName}/tables/${tableID}/replace`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body
      }
    }
  };
}

export const [
  APPEND_TO_TABLE,
  APPEND_TO_TABLE_REQUEST,
  APPEND_TO_TABLE_SUCCESS,
  APPEND_TO_TABLE_FAILURE
] = api.buildTypes('APPEND_TO_TABLE');

export function appendToTable({ teamName, tableID, body }) {
  return {
    type: APPEND_TO_TABLE,
    payload: {
      url: `/teams/${teamName}/tables/${tableID}/append`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body
      }
    }
  };
}

export const [
  ADD_TABLE_COLUMN,
  ADD_TABLE_COLUMN_REQUEST,
  ADD_TABLE_COLUMN_SUCCESS,
  ADD_TABLE_COLUMN_FAILURE
] = api.buildTypes('ADD_TABLE_COLUMN');

export function addTableColumn({ teamName, tableID, column }) {
  return {
    type: ADD_TABLE_COLUMN,
    payload: {
      url: `/teams/${teamName}/tables/${tableID}/columns`,
      schema: FIELD_SCHEMA,
      options: {
        method: 'POST',
        body: column
      }
    }
  };
}

export const [
  GET_TABLE_PROCESSES,
  GET_TABLE_PROCESSES_REQUEST,
  GET_TABLE_PROCESSES_SUCCESS,
  GET_TABLE_PROCESSES_FAILURE
] = api.buildTypes('GET_TABLE_PROCESSES');

export function getTableProcesses({ teamName, tableID }) {
  return {
    type: GET_TABLE_PROCESSES,
    payload: {
      url: `/teams/${teamName}/tables/${tableID}/parentprocesses`,
      schema: PROCESS_LIST_SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/table.js